import React from "react"
import styled from "styled-components"
import { Row, Col } from "react-flexbox-grid"
import { rem } from "polished"
import InlineSVG from "react-inlinesvg"
import { Parallax } from "react-scroll-parallax"

import Container from "../container"
import Visual from "../visual"

// import  { ReactComponent as AboutText } from "../../assets/images/about.svg"

const StyledContainer = styled(Container)`
  align-self: center;
`

const StyledRow = styled(Row)``

const IntroSection = styled.div`
  padding-top: ${rem(300)};
  padding-bottom: ${rem(200)};
  display: flex;

  @media ${props => props.theme.desktopDown} {
    padding-bottom: ${rem(100)};
  }

  @media ${props => props.theme.mobileDown} {
    min-height: 0;
    padding-top: ${rem(110)};
    padding-bottom: ${rem(10)};

    ${StyledRow} {
      flex-direction: column-reverse;
    }
  }

  svg {
    display: block;
    width: 100%;
  }
`

const ImageSection = styled.div`
  margin-left: -50%;

  @media ${props => props.theme.mobileDown} {
    margin-left: 0;
    margin-bottom: ${rem(-15)};
  }
`

const TextCol = styled(Col)`
  position: relative;
  z-index: 2;
`

const Intro = props => (
  <IntroSection data-scroll-section>
    <StyledContainer>
      <StyledRow>
        <TextCol lg={6} md={7} lgOffset={1}>
          <Parallax y={[20, -20]}>
            <InlineSVG src={props.introTextImage} />
          </Parallax>
        </TextCol>

        <Col lg={4} md={5}>
          <ImageSection>
            <Visual {...props.introVisual} />
          </ImageSection>
        </Col>
      </StyledRow>
    </StyledContainer>
  </IntroSection>
)

export default Intro
